import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _inherits from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { env } from "src/config/env";
import Service from "./Service";
var LogService = /*#__PURE__*/function (_Service) {
  _inherits(LogService, _Service);
  var _super = _createSuper(LogService);
  function LogService() {
    var _this;
    _classCallCheck(this, LogService);
    _this = _super.call(this); // Chama o constructor da classe pai
    _this.lastMemoryCheck = 0;
    _this.memoryCheckInterval = 30000;
    _this.isLowPowerDevice = _this.detectLowPowerDevice();
    return _this;
  }
  _createClass(LogService, [{
    key: "detectLowPowerDevice",
    value: function detectLowPowerDevice() {
      var userAgent = navigator.userAgent.toLowerCase();
      var isTV = userAgent.includes('tv') || userAgent.includes('webos') || userAgent.includes('tizen') || userAgent.includes('chromecast') || userAgent.includes('roku');
      var hasLimitedMemory = navigator.deviceMemory && navigator.deviceMemory <= 2;
      var isMobileLowEnd = /android|iphone|ipad/i.test(userAgent) && hasLimitedMemory;
      return isTV || hasLimitedMemory || isMobileLowEnd;
    }
  }, {
    key: "save",
    value: function save() {
      var _console, _console2, _console3, _console4;
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'log';
      var component = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'UNKNOWN';
      try {
        // if (window.PAINEL_DEBUG) {

        var timestamp = new Date().toISOString();
        var prefix = "[".concat(timestamp, "] [").concat(component, "]");
        for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          args[_key - 2] = arguments[_key];
        }
        switch (type) {
          case 'warn':
            (_console = console).warn.apply(_console, [prefix].concat(args));
            break;
          case 'info':
            (_console2 = console).info.apply(_console2, [prefix].concat(args));
            break;
          case 'error':
            (_console3 = console).error.apply(_console3, [prefix].concat(args));
            break;
          default:
            (_console4 = console).log.apply(_console4, [prefix].concat(args));
        }
        if (!this.isLowPowerDevice) {
          this.checkMemoryUsage();
        }
        // }

        if (env.saveLog && type !== 'log') {
          this.saveRequest(component, type, args.join(' '));
        }
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: "checkMemoryUsage",
    value: function checkMemoryUsage() {
      try {
        var now = Date.now();
        if (now - this.lastMemoryCheck < this.memoryCheckInterval) return;
        this.lastMemoryCheck = now;
        if (!window.performance || !window.performance.memory) return;
        var mem = window.performance.memory;
        var used = (mem.usedJSHeapSize / 1024 / 1024).toFixed(2);
        var total = (mem.totalJSHeapSize / 1024 / 1024).toFixed(2);
        var limit = (mem.jsHeapSizeLimit / 1024 / 1024).toFixed(2);
        var percentage = (mem.usedJSHeapSize / mem.jsHeapSizeLimit * 100).toFixed(1);

        // Alerta se memória alta
        if (percentage > 80) {
          this.save('warn', 'MEMORY_MONITOR', "Mem\xF3ria alta: ".concat(percentage, "% ").concat(used, "MB/").concat(limit, "MB (").concat(percentage, "%) | Total: ").concat(total, "MB"));
          return 'HIGH_MEMORY';
        } else if (percentage > 60) {
          this.save('info', 'MEMORY_MONITOR', "Mem\xF3ria moderada: ".concat(percentage, "% ").concat(used, "MB/").concat(limit, "MB (").concat(percentage, "%) | Total: ").concat(total, "MB"));
          return 'MEDIUM_MEMORY';
        }
        return 'OK';
      } catch (e) {
        console.error('[MEMORY_MONITOR] Erro ao verificar uso de memória:', e);
        return 'ERROR';
      }
    }

    // Desativado para pegar todos logs sempre
    // setDebugMode(enabled) {
    //     window.PAINEL_DEBUG = enabled;
    //     this.save('info', 'LOG_SERVICE', `Debug mode ${enabled ? 'HABILITADO' : 'DESABILITADO'}`);
    // }
  }, {
    key: "forceMemoryCheck",
    value: function forceMemoryCheck() {
      this.lastMemoryCheck = 0;
      return this.checkMemoryUsage();
    }
  }, {
    key: "saveRequest",
    value: function saveRequest(type, origin, message) {
      try {
        var body = {
          "origin": origin || "UNKNOWN",
          "errorMessage": message || "Mensagem não informada",
          "type": type || "info",
          "createdAt": new Date().toISOString()
        };
        this.post('log/internal', body, this.getHeaders().headers["Content-Type"].concat(";charset=UTF-8"));
      } catch (error) {
        console.error('[LOG_SERVICE] Erro ao salvar log:', error);
      }
    }
  }]);
  return LogService;
}(Service);
export default new LogService();